// „Original“ view of the Abgleich: the imported statement PDF, page by page and unchanged, with a tick overlay next
// to every ticked booking — at the same place the printed PDF gets it (backend stamp.ts).
import { useEffect, useState } from 'react';
import type { PDFDocumentProxy } from 'pdfjs-dist';
import { openPdf } from '../../components/pdf/pdfjs';
import { PdfPage, type PageSize } from '../../components/pdf/PdfPage';
import { ensurePdfCss } from '../../components/pdf/css';

export interface Mark { page: number; y: number; height: number | null; right: number | null; pageW: number | null; pageH: number | null; ok: boolean }

export function TickedPdf({ url, marks, width = 560 }: { url: string; marks: Mark[]; width?: number }) {
  ensurePdfCss();
  const [doc, setDoc] = useState<PDFDocumentProxy | null>(null), [sizes, setSizes] = useState<PageSize[]>([]), [err, setErr] = useState(false);
  useEffect(() => {
    let off = false; setDoc(null); setErr(false);
    openPdf(url).doc.then(async (d) => {
      const s: PageSize[] = [];
      for (let i = 1; i <= d.numPages; i++) { const vp = (await d.getPage(i)).getViewport({ scale: 1 }); s.push({ w: vp.width, h: vp.height }); }
      if (!off) { setDoc(d); setSizes(s); }
    }, () => !off && setErr(true));
    return () => { off = true; };
  }, [url]);
  if (err) return <div style={{ font: "500 12px/1 'JetBrains Mono',monospace", color: '#B9B5B6', padding: 40 }}>Vorschau nicht verfügbar</div>;
  if (!doc) return <div style={{ font: "500 12px/1 'JetBrains Mono',monospace", color: '#B9B5B6', padding: 40 }}>PDF wird geladen …</div>;
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16, alignSelf: 'flex-start' }}>
      {sizes.map((sz, i) => {
        const scale = width / sz.w;
        return (
          <div key={i} style={{ position: 'relative', width: sz.w * scale, height: sz.h * scale, boxShadow: '0 14px 40px rgba(0,0,0,.5)' }}>
            <PdfPage doc={doc} n={i + 1} size={sz} scale={scale} rotation={0} text={false} />
            {marks.filter((m) => m.page === i + 1 && m.ok).map((m, k) => {
              const sx = m.pageW ? sz.w / m.pageW : 1, sy = m.pageH ? sz.h / m.pageH : 1;
              const cy = (m.y + Math.min(m.height ?? 9, 10) / 2) * sy * scale, x = Math.min(sz.w - 22, ((m.right ?? sz.w - 34) + 9) * sx) * scale;
              return (
                <svg key={k} width={18 * scale * 1.6} height={16 * scale * 1.6} viewBox="0 0 24 20" fill="none" stroke="#1375BD" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round"
                  style={{ position: 'absolute', left: x, top: cy - 8 * scale * 1.6, pointerEvents: 'none' }}><path d="M3 11l6 6L21 3" /></svg>
              );
            })}
          </div>
        );
      })}
    </div>
  );
}
